import {
  CustomFieldSelectedOption,
  CustomFieldType,
} from 'admin/customFields/entities/customFields.entity';
import { WritableAtom } from 'jotai';
import { CustomFieldSelect } from './CustomFieldSelect';
import { CustomFieldTextField } from './CustomFieldTextField';
import { CustomFields } from 'src/simInventory/models/SimProfile.model';
import { customFieldsHintsAtom } from 'src/atoms/hints/sim';

type CustomFieldInputProps = {
  id: number;
  name: string;
  type: CustomFieldType;
  customFieldsFilterAtom: WritableAtom<CustomFields, [CustomFields], void>;
  customFieldsHintsAtom: typeof customFieldsHintsAtom;
  selectionOptions?: CustomFieldSelectedOption[];
};

export const CustomFieldInput = ({
  id,
  name,
  type,
  selectionOptions = [],
  customFieldsFilterAtom,
  customFieldsHintsAtom,
}: CustomFieldInputProps) => {
  return type === 'Text' ? (
    <CustomFieldTextField
      id={id}
      name={name}
      customFieldsFilterAtom={customFieldsFilterAtom}
      customFieldsHintsAtom={customFieldsHintsAtom}
    />
  ) : (
    <CustomFieldSelect
      id={id}
      name={name}
      customFieldsFilterAtom={customFieldsFilterAtom}
      customFieldsHintsAtom={customFieldsHintsAtom}
      selectionOptions={selectionOptions}
    />
  );
};
